// Add keys for new open feature flags in this object
const OpenFeatureFlags = {
    job_from_website_to_dev_portal_id: "job_from_website_to_dev_portal_id",
    job_from_website_to_dev_portal_code: "job_from_website_to_dev_portal_code"
}

export default OpenFeatureFlags;